import { Button, Legacyprofile as LegacyprofileData, Publicprofile } from '@/payload-types'
import ButtonComponent from '../button/button'
import { createProfilebutton } from '@/lib/postFunctions'
import { CANARY_MISSION } from '@/enum/enum'

interface IProps {
  profileData: (string | null) | LegacyprofileData | Publicprofile
  buttonCSS?: string
  href?: string
}

export const SeeProfileBtn = ({ profileData, buttonCSS, href }: IProps) => {
  let button: Button | null | string = null
  button = createProfilebutton(profileData)
  return (
    <div className="w-fit">
      <ButtonComponent
        url={`${CANARY_MISSION.BASIC_URL}${href}`}
        buttonData={button}
        size={'xs'}
        buttonCSS={buttonCSS}
      />
    </div>
  )
}

export default SeeProfileBtn
